import { useState, useCallback } from "react";
import { productService } from "../services/productService";

export const useProductGeneralDetail = () => {
  const [productDetail, setProductDetail] = useState(null); // Ürün genel detayı
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProductById = useCallback(async (productId) => {
    if (!productId) return;

    setLoading(true);
    setError(null);
    setProductDetail(null);
    try {
      const productData = await productService.getProductById(productId);
      console.log("useProductGeneralDetail - Gelen Product Data:", productData);
      setProductDetail(productData);
      return productData;
    } catch (err) {
      setError(err.message || "Ürün genel detayı getirilemedi");
      console.error("Ürün genel detayı getirme hatası:", err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    productDetail,
    loading,
    error,
    fetchProductById,
  };
};

export default useProductGeneralDetail;
